module.exports = __webpack_public_path__ + "img/ranking-top5.aa846524.png";